define((require) => {
    "use strict";

    const Action       = require("shared/ui/experience/action/Action");
    const ViewerEvents = require("shared/services/ViewerEvents");

    const NEXT     = "next";
    const PREVIOUS = "previous";

    /**
     * Action that navigates to another scene in the experience.
     *
     * @class SceneNavigationAction
     * @constructor
     */
    return Action.extend("SceneNavigationAction", {

        defaults: {
            target: NEXT
        },

        _event: ViewerEvents.SCENE_NAVIGATE,

        // Pause the current Experience and all its parent(s) on user navigation; by default, this will
        // disable auto play as well...
        _paused: true,

        /**
         * @protected
         * Activates this action.
         *
         * @param {ExperienceViewModel} experienceViewModel The view model for the experience being viewed.
         */
        _activate(experienceViewModel) {
            const previous = experienceViewModel.get("currentScene");
            const target = this.get("target");

            if (target === NEXT) {
                experienceViewModel.goToNextScene();
            } else if (target === PREVIOUS) {
                experienceViewModel.goToPreviousScene();
            } else {
                const numScenes = experienceViewModel.get("experience").get("scenes").length;
                if (target > 0 && target <= numScenes) {
                    experienceViewModel.goToScene(target);
                }
            }

            // For event triggering...
            return Object.assign(
                {actionId: this.id, widgetId: this.attributes.widgetId},
                {data: {target, current: experienceViewModel.get("currentScene"), previous}}
            );
        }

    }, {
        TYPE: "sceneNavigation",
        NEXT,
        PREVIOUS
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/sceneNavigation/SceneNavigationAction.js